import { render, staticRenderFns } from "./MessageTab.vue?vue&type=template&id=1ed8f26e&scoped=true&"
import script from "./MessageTab.vue?vue&type=script&lang=ts&"
export * from "./MessageTab.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTab.vue?vue&type=style&index=0&id=1ed8f26e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8f26e",
  null
  
)

export default component.exports